import React from 'react';
import { CheggHeaderLogo } from '@chegg-ui/theme';
import { LogoLink } from '../styles';
import { NavType } from '../types';
import navProductNames from './navProductNames';

var HeaderLogoLink = function HeaderLogoLink(_ref) {
  var envUrl = _ref.envUrl,
      onClick = _ref.onClick,
      navType = _ref.navType;
  return /*#__PURE__*/React.createElement(LogoLink, {
    href: "".concat(envUrl).concat(navType === NavType.home ? '' : navType),
    onClick: onClick,
    "data-test": "header-logo"
  }, /*#__PURE__*/React.createElement(CheggHeaderLogo, {
    productName: !navType || navType === NavType.home ? undefined : navProductNames[navType]
  }));
};

HeaderLogoLink.displayName = 'HeaderLogoLink';
export default HeaderLogoLink;